/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'ordered-grid-controls';
const prefix = `${moduleName}.${componentName}`;

export const createTitle = `${prefix}.createTitle`;
export const searchInputPlaceholder = `${prefix}.searchInputPlaceholder`;

export const ENGLISH = {
    [createTitle]: 'Create',
    [searchInputPlaceholder]: 'Search',
};
